import React from "react";
import styled from "styled-components";

const InfoDiv = styled.div`
  display: block;
  padding: 0.8rem 0.6rem;
  font-size: 0.87em;
  border-radius: 5px;
`;

export const Info = props => {
  return <InfoDiv>{props.children}</InfoDiv>;
};



// WEBPACK FOOTER //
// ./src/components/common/form/modules/Info.tsx